<template>
  <a-spin
    tip="Your document is being processed, do not leave this page!"
    :spinning="loading.tab"
  >
    <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
      <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
        <a-card>
          <div slot="title"><a-icon type="file-search" />&nbsp;Search</div>
          <ul class="m-list-wrapper">
            <li>
              <a-input-search v-model="search" placeholder="Quick Search" />
            </li>
            <li>
              <a-collapse :activeKey="getScreen ? 0 : 1">
                <a-collapse-panel key="1">
                  <span slot="header">Search More...</span>
                  <div class="m-form-item-wrapper">
                    <label>Transaction Date</label>
                    <a-range-picker
                      :placeholder="['Start Date', 'End Date']"
                      v-model="transactionDt"
                      :format="getDefaultDateFormat"
                    />
                  </div>
                </a-collapse-panel>
              </a-collapse>
            </li>
          </ul>
        </a-card>
      </a-col>
      <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
        <DataList
          :loading="loading.list"
          :title="'PBK'"
          :disabledCreateEditLink="false"
          createLink="PBKCreate"
          manifestLink="pbkManifest"
          :tabbedTransactional="true"
          :dataList="resultSearch"
          dataListTitle="Request"
          :otherList="resultSearch"
          otherListTitle="Realisasi"
        >
          <!-- <div slot="titleAdvanced">
              <a-button type="primary" @click="togenerate()">Generate</a-button>
          </div>
          <div slot="actions" slot-scope="item">
            <a-button-group class="margin-top">
              <a-button icon="edit" @click="sptEdit(item)" type="dash" v-if="item.source.rightStatusBesar && item.source.rightStatusBesar != 'Release' && item.source.rightStatusBesar != 'Done'">{{ item.source.rightStatusBesar == 'Revised' ? 'Revise' : 'Edit' }}</a-button>
              <a-button icon="delete" @click="sptDelete(item.source.id)" type="danger" v-if="item.source.rightStatusBesar == 'On Process' && item.source.pembetulan_sts == '0'">Delete</a-button>
              <a-button icon="form" type="primary" v-if="item.source.pembetulan_sts == '1' && item.source.rightStatusBesar == 'Done'" @click="sptPembetulan(item)" :loading="loadings.recti">Pembetulan SPT</a-button>
            </a-button-group>
          </div> -->
        </DataList>
      </a-col>
    </a-row>
  </a-spin>
</template>

<script>
// import axios from "axios";
import { mapGetters } from "vuex";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import GlobalMethod from "@/mixins/GlobalMethod";
import moment from "moment";
import _ from "lodash";

export default {
  name: "ListPBK",
  mixins: [GlobalMethod, CurrencyFormat],
  data() {
    return {
      loading: {
        tab: false,
        list: false,
      },
      resultSearch: [],
      search: null,
      transactionDt: null,
      activetab: "Need Process",
      source: [],
    }
  },
  mounted() {
    this.$store.dispatch("Fetch_TYPE_TAX");
    Event.$on("callbackTab", this.clickTabed);
    this.fetchData()
  },
  beforeDestroy() {
    Event.$off("callbackTab", this.clickTabed);
  },
  watch: {
    search() {
      this.dataSearch()
    },
    transactionDt() {
      this.dataSearch()
    },
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getType_tax",
    ]),
  },
  methods: {
    moment,
    fetchData() {
      this.loading.tab = true;
      this.asyncAxiosGet("pbk",
        this.getAuth,
        {
          tab:  this.activetab
        }
      ).then((res) => {
        let temp = res.list
        let temp2 = [];
        for (let i = 0; i < temp.length; i++) {
          temp2.push({
            title: temp[i].request_pbk_no,
            timeline: null,
            unread: false,
            subdesc: [
              moment(temp[i].create_dt).format(this.getStandartFormatDate) +" | "+ temp[i].tlc_create,
              [{label: "NTPN :",
                value: temp[i].ntpn_no}],
              [{label: "Tax Type From :",
                value: this.labelingTax(temp[i].tax_type_from),}],
              [{label: "Value From :",
                value: this.formatRupiah(temp[i].value_from),}],
              [{label: "Tax Type To :",
                value: this.labelingTax(temp[i].tax_type_to),}],
              [{label: "Value To :",
                value: this.formatRupiah(temp[i].value_req_pbk),}],
              "Note : " + (temp[i].request_note ? temp[i].request_note :""),
            ],
            rightStatusBesar: temp[i].request_pbk_sts,
            id: temp[i].request_pbk_id,
            create_dt: temp[i].create_dt,
            q_search: temp[i].kap_from.toLowerCase() + temp[i].kap_to.toLowerCase() + temp[i].kjs_from.toLowerCase()
              + temp[i].kjs_to.toLowerCase() + temp[i].ntpn_no.toLowerCase() + (temp[i].request_note ? temp[i].request_note.toLowerCase() : "")
              + temp[i].request_pbk_no.toLowerCase() + temp[i].tlc_create.toLowerCase()
          })
        }
        this.source = temp2;
        this.dataSearch()
        this.loading.tab = false;
      }).catch(() => {
        this.loading.tab = false;
      });
    },
    dataSearch() {
      let tempdata = this.source;
      if (this.transactionDt && this.transactionDt.length>0) {
        let start = this.transactionDt[0].format(this.getStandartFormatDate)
        let end = this.transactionDt[1].format(this.getStandartFormatDate)
        this.resultSearch = _.filter(tempdata, (item) =>
          moment(item.create_dt).format(this.getStandartFormatDate) >= start
          && moment(item.create_dt).format(this.getStandartFormatDate)  <= end)
      }

      if (this.search && this.search!="") {
        this.resultSearch = _.filter(tempdata, (item) =>
          item.q_search.indexOf(this.search.toLowerCase()) >=0
        )
      }

      if (!this.search && !(this.transactionDt && this.transactionDt.length > 0)) {
        this.resultSearch = tempdata
      }
    },
    clickTabed(val) {
      if (val == "list") {
        this.activetab = "Need Process"
      }else{
        this.activetab = "Processed"
      }
      this.fetchData()
    },
    labelingTax(val) {
      let result = _.filter(this.getType_tax, (item) => item.value == val);
      return (result.length > 0 ? result[0].text : "");
    }
  }
}
</script>